export const loadJSON = async (path) => {
	return fetch(path)
		.then((r) => r.json())
		.catch(() => resolve(undefined));
};
